import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './plugins/firebase'
import './styles/custom-transitions'
import './plugins/vue-carousel'
import './assets/fonts/metropolis/stylesheet.css'
import './assets/fonts/heebo/stylesheet.css'
import './assets/fonts/ibm-plex-serif/stylesheet.css'

Vue.config.productionTip = false

Vue.prototype.$goTo = async function ({ path, target }) {
  const options = {
    duration: 300,
    offset: 0,
    easing: 'easeInOutCubic'
  }

  // if not on requested path, redirect before scrolling
  if (router.currentRoute.path !== path) await router.push(path)

  if (target) {
    // offset background negative margin for this section
    if (store?.state?.page?.alert?.model) options.offset = 72

    await vuetify.framework.goTo(target, options)
    return
  }
  await vuetify.framework.goTo(0)
}

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount('#app')
